import APIV5 from '~/models/api';

export default class ModalInfoController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	constructor($scope, $uibModalInstance, kid) {
		this.$uibModalInstance = $uibModalInstance;
		this.kid = kid;

		/** @type {string | undefined} */
		this.tab = undefined;
		this.$onInit();
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	$onInit() {
		if (this.kid) {
			APIV5.instance.get({ elt_kid: this.kid }, { id: 'oo-admin.modal-info' }).then((/** @type {any} */ data) => {
				this.tab = data[this.kid];
				return this.tab;
			}).catch(() => {
				this.tab = undefined;
			});
		}
	}
}
